import {getDispatcher} from '@soluto-private/mx-analytics';

const _dispatcher = getDispatcher({path: '/', packageName: 'partner'});

export const dispatchAnalytics = (eventName: string, extraData?: {[key: string]: unknown}): void =>
    _dispatcher.dispatch(eventName, {ExtraData: {...extraData}});

export default _dispatcher;
